import { FaChartLine } from "react-icons/fa6";
import { riskOptions } from "../../../utility/data";
import AlertConfigOption from "./AlertConfigOption";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import RiskAppetiteModal from "./RiskAppetiteModal";

function RiskAppetiteBox() {
  const [showConfigModal, setShowConfigModal] = useState(false);

  const { alertStatus } = useSelector((state) => state.alertSystem);

  return (
    <AlertConfigOption
      title="Risk Appetite"
      icon={<FaChartLine />}
      onClick={() => setShowConfigModal(true)}
    >
      <p>
        Currently:{" "}
        <span>{riskOptions[+alertStatus?.risk_taking_amount - 1]}</span>
      </p>
      {showConfigModal && (
        <RiskAppetiteModal
          open={showConfigModal}
          onClose={() => setShowConfigModal(false)}
        />
      )}
    </AlertConfigOption>
  );
}

export default RiskAppetiteBox;
